import SEOHead from "@/components/SEOHead";
import Header from "@/components/landing/Header";
import Footer from "@/components/landing/Footer";
import ScrollToTop from "@/components/landing/ScrollToTop";


import HomeHero from "@/components/home/HomeHero";
import HomeCredentialBar from "@/components/home/HomeCredentialBar";

import HomeRecentProjects from "@/components/home/HomeRecentProjects";
import HomeTestimonials from "@/components/home/HomeTestimonials";
import { HomeSpecialtyFinishes, HomePreparation, HomeBeforeAfter, HomeFinishStudio, HomeResidentialCommercial } from "@/components/home/HomeSeoSections";
import HomeFinalCTA from "@/components/home/HomeFinalCTA";
import HomeShopMeoded from "@/components/home/HomeShopMeoded";
import HomeCustomSamples from "@/components/home/HomeCustomSamples";
import HomeWallPrinting from "@/components/home/HomeWallPrinting";

import HomepageFAQ, { homepageFaqData } from "@/components/landing/HomepageFAQ";
import { homeTestimonials } from "@/data/homeTestimonials";


const faqSchemaData = homepageFaqData.map((faq) => ({
  question: faq.question,
  answer: faq.answer,
}));

const reviewSchemas = homeTestimonials.map((t) => ({
  author: t.name,
  reviewBody: t.quote,
  ratingValue: t.rating,
}));

/** Merged into the sitewide LocalBusiness entity (same @id) — no duplicate business. */
const homeLocalBusinessOverrides = {
  "@type": [
    "LocalBusiness",
    "HomeAndConstructionBusiness",
    "Plasterer",
    "HousePainter",
  ],
  description:
    "All Time Paint & Plaster Co. specializes in Venetian plaster, decorative lime plaster, limewash and microcement for residential and commercial spaces throughout North Jersey, with professional painting as an additional service. Based in Wayne, NJ.",
  areaServed: [
    { "@type": "City", name: "Wayne" },
    { "@type": "AdministrativeArea", name: "Bergen County" },
    { "@type": "AdministrativeArea", name: "Passaic County" },
    { "@type": "AdministrativeArea", name: "Morris County" },
    { "@type": "AdministrativeArea", name: "Essex County" },
    { "@type": "AdministrativeArea", name: "Hudson County" },
    { "@type": "AdministrativeArea", name: "Northern New Jersey" },
  ],
  knowsAbout: [
    "Interior Painting",
    "Exterior Painting",
    "Venetian Plaster",
    "Lime Plaster",
    "Limewash Painting",
    "Microcement",
    "Decorative Plaster Finishes",
    "Wallpaper Installation",
    "Specialty Wall Finishes",
    "Residential Painting",
    "Commercial Painting",
  ],
  hasOfferCatalog: {
    "@type": "OfferCatalog",
    name: "Painting & Decorative Plaster Services",
    itemListElement: [
      "Interior Painting",
      "Exterior Painting",
      "Venetian Plaster",
      "Lime Plaster",
      "Limewash",
      "Microcement",
      "Decorative Plaster Finishes",
      "Wallpaper Installation",
      "Residential Painting",
      "Commercial Painting",
    ].map((name) => ({
      "@type": "Offer",
      itemOffered: { "@type": "Service", name },
    })),
  },
};

const Index = () => {
  return (
    <main className="min-h-screen pb-24 md:pb-0">
      <SEOHead
        title="Venetian Plaster & Limewash NJ | All Time Paint & Plaster Co."
        description="Venetian plaster, limewash and microcement installation across North Jersey. Explore our completed projects and visit our Wayne finish studio by appointment."
        ogTitle="Venetian Plaster & Limewash NJ | All Time Paint & Plaster Co."
        ogDescription="Venetian plaster, limewash and microcement installation across North Jersey. Explore our completed projects and visit our Wayne finish studio by appointment."
        canonicalUrl="https://alltimepaintandplaster.com/"
        townName="Wayne"
        faqItems={faqSchemaData}
        reviews={reviewSchemas}
        localBusinessSchema={homeLocalBusinessOverrides}
        isHomePage={true}
      />

      <Header />

      <HomeHero />
      <HomeCredentialBar />
      <HomeRecentProjects />
      <HomeSpecialtyFinishes />
      <HomeBeforeAfter />
      <HomePreparation />
      <HomeFinishStudio />
      <HomeTestimonials />
      <HomeResidentialCommercial />
      <HomeWallPrinting />
      <HomepageFAQ />
      <HomeFinalCTA />
      <HomeCustomSamples />
      <HomeShopMeoded />

      <Footer />
      <ScrollToTop />
    </main>
  );
};

export default Index;
